<template>
    <div>
        <form @submit.prevent="pressOk">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <strong>Nombre</strong>
                        <input type="text" v-model="sReason.name" class="form-control no-limited" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <button class="btn btn-block btn-success">
                            <i class="fa fa-save"></i>
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import { Post, Get } from "../../helper/axios.js";
import toastr from "toastr";
export default {
    data() {
        return {
            apiUrl: this.$store.getters.apiUrl,
            Post,
            Get
        };
    },
    props: ["sReason"],
    created() {
    },

    methods: {
        pressOk() {
            if (this.sReason) {
                var valid = true;
                var message = "Agregue o corrija los siguiente campos:<br>";
                if (!this.sReason.name) {
                    message = message + "* Nombre.<br>";
                    valid = false;
                }
                if (valid) {
                    this.$emit("pressOk");
                } else {
                    toastr.info(message);
                }
            }
        },
    }
};
</script>
